// 当前登录用户与超级管理员判定（isadmin === 2）

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

/** 超级管理员：isadmin === 2（与 Header / SettingsPage 一致） */
export function isSuperAdmin(user = getCurrentUser()) {
  return Number(user?.isadmin) === 2;
}

/** 仅超级管理员可见的增值菜单/路由 */
export const SUPER_ONLY_PATHS = ['/app/display/3d', '/app/biz/settle'];

export function isSuperOnlyPath(path) {
  return SUPER_ONLY_PATHS.includes(path);
}
